import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTACT_PAGE: `${cleanedFilename(__filename)}-contact-page`,
};
